<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'presupuesto-general', title: '4.1 Presupuesto general de ingresos, gastos e inversión' },
  { id: 'ejecucion-presupuestal', title: '4.2 Ejecución presupuestal' },
  { id: 'plan-accion', title: '4.3 Plan de Acción' },
  { id: 'proyectos-inversion', title: '4.4 Proyectos de Inversión' },
  { id: 'informes-empalme', title: '4.5 Informes de empalme' },
  { id: 'info-publica', title: '4.6 Información pública y/o relevante' },
  { id: 'informes-gestion', title: '4.7 Informes de gestión, evaluación y auditoría' },
  { id: 'informes-control-interno', title: '4.8 Informes de la Oficina de Control Interno' },
  { id: 'informe-defensa', title: '4.9 Informe sobre Defensa Pública y Prevención del Daño Antijurídico' },
  { id: 'informes-acceso', title: '4.10 Informes trimestrales sobre acceso a información, quejas y reclamos' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="4. Planeación, Presupuesto e Informes" />
</template>
